import * as React from 'react';
import { useContext, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import MenuItem from '@mui/material/MenuItem';
import { MyContext } from '../../context/MyContext';
import { BrowserView, MobileView } from 'react-device-detect';
import { fontSize } from '@mui/system';

const options = ['Código', 'Descrição', 'Maiores Preços', 'Menores Preços', 'Nº Original'];

export default function ControllableStates() {
    const { produtosOrdem, setProdutosOrdem } = useContext(MyContext);
    const { posicaoOrdem, setPosicaoOrdem } = useContext(MyContext);
    const [ valueSelecionado, setValueSelecionado] = React.useState();
    const [inputValue, setInputValue] = React.useState('');

    useEffect(() => {
        if (valueSelecionado == "Código") {
            setProdutosOrdem("codigo");
        }
        else if (valueSelecionado == "Descrição") {
            setProdutosOrdem("descricao");
        }
        else if (valueSelecionado == "Maiores Preços") {
            setProdutosOrdem("preco");
            setPosicaoOrdem("desc");
        }
        else if (valueSelecionado == "Menores Preços") {
            setProdutosOrdem("preco");
            setPosicaoOrdem("asc");
        }
        else if (valueSelecionado == "Nº Original") {
            setProdutosOrdem("n_original");
        }
        else {
            setProdutosOrdem("descricao");
        }
    }, [produtosOrdem, valueSelecionado]);   


    return (
        <div style={{ minWidth: '200px', paddingRight: '15px'}} >           
            <BrowserView>
            <TextField 
                fullWidth                
                select size='small'
                label="Ordenar Produtos"
                height="10px"
                //value={value}
                onChange={e => setValueSelecionado(e.target.value)}
            >
                {options.map((option) => (
                    <MenuItem key={option} value={option}>
                        {option}
                    </MenuItem>
                ))}
            </TextField>           
            </BrowserView>    

            <MobileView>
            <TextField 
                fullWidth                
                select size='small'
                label="Ordenar Produtos"
                height="10px"                                
                style = {{width: '85%', marginRight:'12px'}}
                //value={value}
                onChange={e => setValueSelecionado(e.target.value)}
            >
                {options.map((option) => (
                    <MenuItem key={option} value={option}>
                        {option}
                    </MenuItem>
                ))}
            </TextField>           
            </MobileView>

        </div>
    );
}